/*
 * @Author       : lubiao01
 * @File         : 全局事件通知
 * @Date         : 2023-07-12 15:55:39
 */

import __INSTANCE__ from '../InstanceManager';
import {sendYaLog} from '../log';
import {
    registerDataChannel,
    sendbroadcast,
} from './datachannel';
import {isPcClient} from './env';
import {sendMessageToNA} from './native';
import {isSupportedNewMessageVersion} from './tools';

const controller = new AbortController();

type AsyncFunction = (action: string, data: string) => Promise<void>;
type SyncFunction = (action: string, data: string) => void | string;

// 监听消息
export const listenMessage = <T>(
    action: string,
    cb: SyncFunction | AsyncFunction,
    useNewMessage = false,
    unRegFirst = true
) => {
    if (!isPcClient() && (isSupportedNewMessageVersion() || useNewMessage)) {
        window.addEventListener(action, (e: CustomEventInit) => {
            cb(action, e.detail);
        }, {
            signal: controller.signal,
        });
    }
    else {
        registerDataChannel(action, cb as (action: string, data: T) => void | string, unRegFirst);
    }
};

// 发送消息
export const sendMessage = (action: string, payload = {}, useNewSendMessage = false) => {
    if (!isPcClient() && (isSupportedNewMessageVersion() || useNewSendMessage)) {
        sendMessageToNA({
            action,
            params: payload,
        });
    }
    else {
        sendbroadcast(action, payload);
    }
};

export const dispatchMessage = (action: string, params: string) => {
    window.dispatchEvent(
        new CustomEvent(action, {
            detail: typeof params === 'string' ? params : JSON.stringify(params),
        })
    );
};

// 初始化，在window上注册方法让NA发送消息用
export const initMessage = () => {
    // 先清除所有监听
    // controller.abort();

    // eslint-disable-next-line camelcase
    window.__na_2_fe_msg = dispatchMessage;
};

window.addEventListener('DOMContentLoaded', () => {
    listenMessage('com.baidu.newapp.na.notify_pagehide', () => {
        window.webviewHide = true;
        __INSTANCE__.emitter?.emit('hideContextMenu');
        __INSTANCE__.emitter?.emit('notifyNaShowMusicCard');
        __INSTANCE__.emitter?.emit('notifyPageHide');
        sendYaLog(`notify_pagehide_webviewId=${window.webviewId}`);
    }, true);

    listenMessage('com.baidu.newapp.na.notify_pageWillHide', () => {
        __INSTANCE__.emitter?.emit('hideContextMenu');
        __INSTANCE__.emitter?.emit('notifyNaShowMusicCard');
    }, true);

    listenMessage('com.baidu.newapp.na.notify_pageshow', () => {
        window.webviewHide = false;
        __INSTANCE__.emitter?.emit('updateTotalCoin');
        __INSTANCE__.emitter?.emit('notifyPageShow');
        sendYaLog(`notify_pageshow_webviewId=${window.webviewId}`);
    }, true);
});
